import script from "./ServiceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceDetail.vue?vue&type=script&setup=true&lang=js"

import "./ServiceDetail.vue?vue&type=style&index=0&id=801cbbcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-801cbbcc"]])

export default __exports__